import { Injectable, inject } from '@angular/core';
import {Title} from '@angular/platform-browser';
import {ActivationEnd, Router, Event} from '@angular/router';
import {filter} from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class BdPageTitleService {
  private _router = inject(Router);
  private _titleService = inject(Title);
  private readonly _brand = inject<string>('BD_PAGE_TITLE_BRAND' as any, { optional: true });


  private readonly _maxTitleLength = 60;

  public static title(text: string): object {
    return {
      primaryKeyword: `${text}`
    };
  }

  constructor() {
    this._brand = this._brand ? this._brand : 'BinDoc';
  }

  public init(): void {
    this._router.events.pipe(
      filter((event: Event): event is ActivationEnd => event instanceof ActivationEnd),

      // nested routes fire for each path segment an event
      // we only want the nth child event, where no further child exists
      filter((event: ActivationEnd) => event.snapshot.children.length === 0)
    )
      .subscribe((event: ActivationEnd) => this.updateTitle(this._pageTitleFromRoute(event)));
  }

  public pageTitleText(primaryKeyword: string): string {
    if (primaryKeyword) {

      if (primaryKeyword.length > this._maxTitleLength) {
        primaryKeyword = primaryKeyword
          .slice(0, (this._maxTitleLength - 3)) // cut of, what is too long (including space for '...')
          .concat('...');
      }

      return `${primaryKeyword} | ${this._brand}`;
    } else {
      return this._brand;
    }
  }

  public updateTitle(pageTitleText: string) {
    this._titleService.setTitle(pageTitleText);
  }

  private _pageTitleFromRoute(event: ActivationEnd): string {
    if (event.snapshot.data && event.snapshot.data['pageTitle']) {
      const primaryKeyword: string = event.snapshot.data['pageTitle'].primaryKeyword;
      return this.pageTitleText(primaryKeyword);
    } else {
      return this._brand;
    }
  }
}
